namespace SP {
    export enum PurchaseOrderType {
        PurchaseOrder = 0,
        ReturnOrder = 1,
    }
}